<div class="container-categories-list">
    <div class="title-dialog-edit d-flex justify-content-between align-items-center">
        <div>
            <p class="m-0">Selecciona categorías</p>
            <p class="subtitle-dialog m-0">Puedes elegir más de una</p>
        </div>
        <i class="fa-light fa-times m-0 pointer-in" (click)="closeDialog()"></i>
    </div>
    <div *ngIf="loading; else divCategorias">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>
    <ng-template #divCategorias>
        <div>
            <div class="pointer-in" *ngFor="let categoria of categorias" [value]="categoria.id"
                (click)="selectCategory(categoria)">
                <div class="category-option" [class.category-select]="isSelected(categoria)">
                    <i class="fa-thin {{ categoria.icon }} icon-primary fa-lg"></i>
                    <span class="category-name">{{categoria.name}}</span>
                    <i class="fa-solid fa-circle-check check-icon" *ngIf="isSelected(categoria)"></i>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div>
    </ng-template>
    <button class="btn-new-form w-100 btn-save" (click)="saveCategory()" [disabled]="!listCategories.length">Guardar</button>
</div>
